// Team roster, consumed by src/pages/Team.js.

export const leadership = [
  {
    role: 'PROJECT PIs',
    people: [
      { name: 'Ana Bonaca', affil: 'Carnegie', url: 'https://carnegiescience.edu/bio/dr-ana-bonaca' },
      { name: 'Charlie Conroy', affil: 'CfA', url: 'https://cconroy20.github.io/' },
    ],
  },
  {
    role: 'INSTRUMENT PI',
    people: [
      { name: 'Dan Fabricant', affil: 'CfA', url: 'https://www.cfa.harvard.edu/people/daniel-fabricant' },
    ],
  },
  {
    role: 'DEPUTY PROJECT SCIENTIST',
    people: [
      { name: 'Vedant Chandra', affil: 'CfA', url: 'https://vedantchandra.com/' },
    ],
  },
  {
    role: 'DEPUTY INSTRUMENT PI',
    people: [
      { name: 'Jack Piotrowski', affil: 'Carnegie', url: 'https://jack-piotrowski.com/' },
    ],
  },
];

export const members = [
  {
    institution: 'At Carnegie:',
    names: 'Ebtihal Abdelaziz, Andrew Benson, Luke Bouma, Jeffrey Crane, David Cruz, Sten Delos, Julian Garcia, Charlie Hull, Casey Lam, Jake Nibauer, Nondh Panithanpaisal, Jack Piotrowski, Tony Piro, Josh Simon, Jessica Spake, Shreyas Vissapragada, Newlin Weatherford, Julie Xue',
  },
  {
    institution: 'At the CfA:',
    names: 'Dan Baldwin, Carl Barcroft, Warren Brown, Nelson Caldwell, Phill Cargile, Dan Catropa, Vedant Chandra, Andrew Cline, Liam Connor, Peter Doherty, Yize Dong, Daniel Durusky, Danielle Frostig, Matthew Holman, Ben Johnson, Jan Kansky, Vlad Kradinov, Scott Lucchini, Kyle MacKenzie, Morgan MacLeod, Stephanie Melikian, Catherine Miller, Sean Moran, Mark Mueller, Alex McCarthy, Brian McLeod, Karin Öberg, Martin Paegert, Anya Phillips, William Podgorski, Andrew Schalk, Hunter Snell, Zachary Svec, David Theroux, Andrew Vanderburg, Ashley Villar, Matthew Werneken, Abby White, Joe Zajac',
  },
  {
    institution: 'At Stanford:',
    names: 'Christian Aganze, Jay Baptista, Susan Clark, Tara Dacunha, Ben Dodge, Phil Mansfield, Viraj Manwadkar, Jean Somalwar, Risa Wechsler, Xinyue Zhang',
  },
  {
    institution: 'At Yale:',
    names: 'Earl Bellinger, William Cerny, Marla Geha, Malena Rice, Pieter van Dokkum',
  },
];
